import React from 'react'

import {useParams} from 'react-router-dom'

import {Entities} from '@/typedef'
import {Paper, PaperVariant} from '@/components/paper/paper'

import IncidentKrequestNew from '../../components/incident-k-request/incident-k-request-new/incident-k-request-new'
import {ItsmAssets} from '../../typedef'

const IncidentNew = () => {
  const {id} = useParams<{id: string}>()

  return (
    <Paper variant={PaperVariant.form}>
      <IncidentKrequestNew
        entity={Entities.INCIDENT}
        id={id}
        asset={ItsmAssets.Incidents}
      />
    </Paper>
  )
}

export default IncidentNew
